export default {
  ObterDadosDeAcesso: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "obter-dados-de-acesso"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ObterDadosDeAcesso.js
// module id = Kf3U
// module chunks = 32